<template>
  <section class="p-box">
    <div class="p-box__body">
      <p>店舗に紐づけるブランドを選択してください。</p>
      <div v-if="!loading">
        <p class="c-formLabel">ブランド</p>
        <Select v-model="brand_id" :options="optionBrands" />
        <div v-if="brand_id" class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesGMBLinkageLocations', params: { company_uuid: companyUuid, brand_id: brand_id } }" class="c-button__item c-button__item--primary">
            次へ
          </router-link>
        </div>
      </div>
      <Loading v-else />
    </div>
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Select from '../components/Select'
import Loading from '../components/Loading'

export default {
  name: 'CompaniesGMBLinkageBrand',
  components: {
    Select,
    Loading,
  },
  data() {
    return {
      brand_id: null,
    }
  },
  computed: {
    ...mapState({
      brands: state => state.companiesBrands.data,
      loading: state => state.companiesBrands.loading || state.companiesGoogleOauth.loading,
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    optionBrands() {
      const obj = {}
      this.brands.map(v => {
        const attributes = v.attributes
        obj[attributes.name] = v.id
      })
      return obj
    },
  },
  async created() {
    await this.readBrands(this.companyUuid)
    this.brand_id = this.brands[0].id
  },
  methods: {
    ...mapActions({
      readBrands: 'companiesBrands/readBrands',
      readGoogleOauth: 'companiesGoogleOauth/readGoogleOauth',
    }),
  },
}
</script>

<style lang="scss" scoped>
.p-box {
  padding: 60px 20px;
}
.p-box__body {
  margin: 0 auto;
  max-width: 512px;
}
</style>
